import React, { createContext, useContext, useMemo, useState } from "react";

const FilterContext = createContext(null);

export const CODE_OPTIONS = ["Male Football", "Ladies Football", "Hurling", "Camogie"];
export const TEAM_BUCKET_OPTIONS = ["Seniors", "Minors", "U21", "U12", "U13", "U14", "U15", "U16"]; // UI can hide some if you want

export function FilterProvider({ children }) {
  const [code, setCode] = useState("Male Football");
  const [team, setTeam] = useState("Seniors");
  const [squad, setSquad] = useState("All");
  const [competitions, setCompetitions] = useState([]); // multi select

  const value = useMemo(
    () => ({
      code,
      setCode,
      team,
      setTeam,
      squad,
      setSquad,
      competitions,
      setCompetitions,
    }),
    [code, team, squad, competitions]
  );

  return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
}

export function useFilters() {
  const ctx = useContext(FilterContext);
  if (!ctx) throw new Error("useFilters must be used within FilterProvider");
  return ctx;
}
